// extracted by css-extract-rspack-plugin
export default {"animate-spin-ckpt":"animate-spin-ckpt-GmiAO_","animateSpinCkpt":"animate-spin-ckpt-GmiAO_","wait":"wait-QZykSI","bgHover":"bgHover-snZqLP"};